import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const IQIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="IQ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#BF2714"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#272727"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#009C4E"
          d="M6.685 4.76 5.167 6.1h1.568c.003-.014.096-.462.487-.462.39 0 .487.448.49.462v.963h-4.46C3.045 7.5 2.5 7.5 2.5 7.5s.623-.442.168-1.095l.377-.288s.015.288.268.288c.252 0 .652.11.652.11v-.398l.326-.145v.543h3.016v-.398c.001-.007.022-.107-.085-.107-.108 0-.124.1-.125.107v.187H4.704v-.316L6.39 4.5l.295.26ZM3.746 7.233c.078 0 .141.057.142.125 0 .07-.064.125-.142.125-.078 0-.142-.056-.142-.125 0-.068.064-.125.142-.125Zm4.66-2.494v1.704h.318l.244.61h-.973V4.607l.41.131Zm4.531 0v1.704h.319l.244.61h-.973V4.607l.41.131Zm-.89 2.293H9.884c0-.879.622-.922.622-.922v-.2l.323-.209v.741h.285V5.373l.426-.245V6.44h.258V4.804l.254-.171-.003 2.398Zm-.587-2.32c-.098.19-.503.11-.503.11-.083.109-.29.054-.39.02l.893-.13Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
